import React, { useCallback, useEffect } from 'react';
import { connect, useDispatch } from 'react-redux';
import { useHistory, useLocation, Link } from 'react-router-dom';
import { hideLiteracyModal, showLiteracyModal } from 'actions/app-state';
import { IRootState } from 'store';
import MobileService from 'services/mobile';
import Signal from 'style/imgs/map/signal.svg';
import AdminIco from 'style/imgs/map/admin.svg';
import buttons from 'style/buttons.module.scss';
import styles from './index.module.scss';

const mapStateToProps = (state: IRootState) => ({
  literaclyModalResult: state.appState.literacyModalResult,
  userType: state.users.userData?.type,
});

type Props = ReturnType<typeof mapStateToProps>;

const ButtonsBlock: React.FC<Props> = ({ literaclyModalResult, userType }) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const history = useHistory();

  const openLiteracyModal = useCallback(() => {
    dispatch(showLiteracyModal());
  }, [dispatch]);

  useEffect(() => {
    if (literaclyModalResult) {
      dispatch(hideLiteracyModal());
      history.push(
        MobileService.isMobile ? '/dashboard/scholars' : '/process-steps-admin'
      );
    }
  }, [literaclyModalResult, history, dispatch]);

  const dashboardButtons = (
    <div
      className={`${styles.dashboardButtons} ${
        MobileService.isMobile ? styles.tablet : ''
      }`}
    >
      {userType === 'parent' && (
        <button
          className={buttons.buttonOrange}
          onClick={() => history.push('/map')}
          type="button"
        >
          Go To Scholar View
        </button>
      )}
      <Link
        to={{
          pathname: '/onboarding/profile',
          state: { mode: 'create' },
        }}
      >
        {/* TODO button from components and remove extra styles */}
        <div className={styles.actionBtn}>
          <div className={styles.icon}>
            <img src={AdminIco} alt="ANETA" />
          </div>
          <div>
            {userType === 'parent'
              ? 'Create New Scholar'
              : 'Create New Anetapack'}
          </div>
        </div>
      </Link>
      <div
        className={styles.signalBtn}
        onClick={() => undefined}
        onKeyPress={() => undefined}
        role="button"
        tabIndex={0}
      >
        <img src={Signal} alt="ANETA" />
      </div>
    </div>
  );

  const getButtons = () => {
    switch (location.pathname) {
      case '/map':
      case '/digital-map':
        return (
          <>
            <div
              role="button"
              tabIndex={0}
              className={styles.actionBtn}
              onClick={openLiteracyModal}
              onKeyDown={() => null}
            >
              <div className={styles.icon}>
                <img src={AdminIco} alt="ANETA" />
              </div>
              <div>Admin corner</div>
            </div>
            <div className={styles.signalBtn}>
              <img src={Signal} alt="ANETA" />
            </div>
          </>
        );
      case '/dashboard/scholars':
        // "Go To Scholar View" and "Create New Anetapack" buttons will be here
        return dashboardButtons;
      case '/dashboard/account-settings':
        return dashboardButtons;
      case '/dashboard/billing':
        return dashboardButtons;
      default:
        return null;
    }
  };

  return <div className={styles.buttonsBlock}>{getButtons()}</div>;
};

export default connect(mapStateToProps)(ButtonsBlock);
